import React from "react";
import { useTheme, Theme } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";
import { PropsAdronIcon } from "../../../_app/types";

// Компонент TetherIcon
const MinusIcon = ({ size }: PropsAdronIcon) => {
  const theme: Theme = useTheme();
  return (
    <SvgIcon
      viewBox={size ? `0 0 ${size} ${size}` : undefined}
      style={size ? { width: size, height: size } : undefined}
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.19995 8.99999C3.19995 8.94477 3.24473 8.89999 3.29995 8.89999H14.7C14.7552 8.89999 14.8 8.94479 14.8 8.99999C14.8 9.05519 14.7552 9.09999 14.7 9.09999H3.29995C3.24473 9.09999 3.19995 9.05522 3.19995 8.99999Z"
          fill={theme.palette.text.primary}
          stroke={theme.palette.text.primary}
        />
      </svg>
    </SvgIcon>
  );
};

export default MinusIcon;
